const atgHomepageMyOrdersContent = {
  title: 'Mes commandes',
  tabs: {
    searchByDate: 'Rechercher une commande par date',
    searchByOrder: 'Rechercher par numéro de commande ou bon de commande',
    searchByStatus: 'Rechercher par statut',
  },
  labels: {
    fromDate: 'Date de début',
    toDate: 'Date de fin',
    separatorTo: 'À',
    separatorOr: 'OU',
    salesOrderNumber: 'Entrer le numéro de commande ATG',
    purchaseOrderNumber: 'Entrer le bon de commande client',
    invoiceNumber: 'Entrer le numéro de facture',
    orderStatus: 'Statut de la commande',
    selectOrderStatus: 'Sélectionner le statut de la commande',
    past90Days: 'Afficher les 15 dernières commandes (dans les 90 jours)',
    allOrders: 'Toutes les commandes',
    openOrders: 'Commandes ouvertes',
    shippedOrders: 'Commandes expédiées',
    cancelledOrders: 'Commandes annulées',
    closedOrders: 'Commandes clôturées',
    past30DayOrders: 'Commandes des 30 derniers jours',
    past60DayOrders: 'Commandes des 60 derniers jours',
    past90DayOrders: 'Commandes des 90 derniers jours',
  },
  button: {
    search: 'Rechercher',
    reset: 'Réinitialiser',
  },
};

export const atgHomepageMyOrders = {
  ...atgHomepageMyOrdersContent,
  atgHomepageMyOrders: atgHomepageMyOrdersContent,
};
